module.exports = __webpack_public_path__ + "img/article-icon-107.a2bf77cf.svg";